import { call, put, select, spawn } from 'redux-saga/effects';

import logger from '@elab/core/utils/logger';
import dynaForms from '@elab/core/utils/dynaForms';
import dynaFormsApi from '@elab/core/utils/dynaForms/api';
import wishlistApi from '@elab/core/store/wishlist/api';
import analytics from '@elab/core/utils/analytics';
import { actions as globalActions } from '@elab/core/store/global';
import { selectors, actions as wishlistActions } from '@elab/core/store/wishlist';

import actions from './actions';

export function* doSubmit({ email }) {
    const wishlistCode = yield select(selectors.getWishlistCode);
    yield put(wishlistActions.setLoading(true));
    try {
        yield call(wishlistApi.shareWishlist, wishlistCode, email);
        yield put(globalActions.toggleFlashMessage('shareWishlist', 'success', true));
        yield put(actions.setVerificationState(true));
        yield put(actions.setShareEmailId(email));
        yield call(analytics.handleShareWishlistEvent);
        yield put(actions.resetFormData());
    } catch (e) {
        yield spawn(logger.error, e);
    } finally {
        yield put(wishlistActions.setLoading(false));
    }
}

export default storeName => formId => [
    ...dynaForms.createSagaFor(
        storeName,
        dynaFormsApi.getFormMetadata(formId || storeName),
        doSubmit,
        null,
        true,
    ),
];
